import { EventQBus } from '../types/global';
import { TrackingFeature } from './TrackingFeature';

export class ContentTracking {
    private readonly eventQBus: EventQBus;
    private readonly richContentElement: HTMLElement;
    private readonly variationId: number | 'missing';
    private visibilityTracked = false;

    constructor(eventQBus: EventQBus, dataContainer: HTMLElement, variationId: number | 'missing') {
        this.eventQBus = eventQBus;
        this.richContentElement = dataContainer;
        this.variationId = variationId;
    }

    public trackPageImpression(): void {
        const trackingFeature = TrackingFeature.createRootFeature('rc-pi', 'RichContent', 'loaded', {});

        this.addWinnerProviderAndModules(trackingFeature, 'loaded');

        const otherProviderNames = this.getOtherProviderNames();
        otherProviderNames.forEach(name => {
            this.addProvider(trackingFeature, name, 'hidden');
        });

        this.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', trackingFeature.toArray());
    }

    public trackRichContentVisibleIfRequired(): void {
        if (!this.visibilityTracked && this.isRichContentVisible()) {
            this.trackRichContentVisible();
            this.visibilityTracked = true;
        }
    }

    trackRichContentVisible(): void {
        const trackingFeature = TrackingFeature.createRootFeature('rc-scrl', 'RichContent', 'visible', {});

        this.addWinnerProviderAndModules(trackingFeature, 'visible');

        //use 'scroll' for resize too
        this.eventQBus.emit('tracking.bct.submitAction', 'scroll', { product_VariationId: this.variationId }, trackingFeature.toArray());
    }

    private addWinnerProviderAndModules(parent: TrackingFeature, status: string): TrackingFeature {
        let provider = this.addProvider(parent, this.getProviderName(), status);
        for (let i = 0; i < this.getModuleCount(); i++) {
            this.addModule(provider, status);
        }
        return provider;
    }

    private addProvider(parent: TrackingFeature, name: string, status: string): TrackingFeature {
        return parent.addChild('p', 'RichContent-Provider', status, { product_RichContentProvider: [name] });
    }

    private addModule(parent: TrackingFeature, status: string): TrackingFeature {
        return parent.addChild('m', 'RichContent-Modul', status, {});
    }

    isRichContentVisible(): boolean {
        const contentContainerTop = this.richContentElement.getBoundingClientRect().top;
        // if a div is invisible, the bounding client rect is always {0, 0, 0, 0}
        if (0 === contentContainerTop) {
            return false;
        }
        const viewportHeight = document.documentElement.clientHeight;
        const visibleHeight = viewportHeight - contentContainerTop;
        return visibleHeight > 100;
    }

    getProviderName(): string {
        return this.richContentElement.getAttribute('data-provider') ?? 'missing';
    }

    getModuleCount(): number {
        return this.richContentElement.querySelectorAll('.rc_teaser')?.length ?? 0
    }

    getOtherProviderNames(): string[] {
        let otherProviders = trimToNull(this.richContentElement.getAttribute('data-other-providers'));
        return otherProviders?.split('|') ?? [];
    }
}

function trimToNull(value: string | null): string | null {
    return value?.trim() || null;
}
